/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, unknown } from '../schema';
import { Data, dataSchema } from './data';
import { Links, linksSchema } from './links';
import { Risk, riskSchema } from './risk';

export interface AC9Checkaccountaccessconsentstatus {
  data: Data;
  risk: Risk;
  links: Links;
  meta?: unknown;
}

export const aC9CheckaccountaccessconsentstatusSchema: Schema<AC9Checkaccountaccessconsentstatus> = object(
  {
    data: ['Data', lazy(() => dataSchema)],
    risk: ['Risk', lazy(() => riskSchema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', unknown()],
  }
);
